/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    IdeaDraftAdmin,
    IdeaDraftAdminFromJSON,
    IdeaDraftAdminToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdeaDraftSearchResponse
 */
export interface IdeaDraftSearchResponse {
    /**
     * Cursor to fetch next set of results.
     * @type {string}
     * @memberof IdeaDraftSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {Array<IdeaDraftAdmin>}
     * @memberof IdeaDraftSearchResponse
     */
    results: Array<IdeaDraftAdmin>;
}

export function IdeaDraftSearchResponseFromJSON(json: any): IdeaDraftSearchResponse {
    return {
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        
        'results': (json['results'] as Array<any>).map(IdeaDraftAdminFromJSON),
        
    };
}

export function IdeaDraftSearchResponseToJSON(value?: IdeaDraftSearchResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'cursor': value.cursor,
        
        'results': (value.results as Array<any>).map(IdeaDraftAdminToJSON),
        
    };
}


